export const ELEMENT_CATEGORIES = [
  {
    name: "Header",
    types: ["companyLogo", "heading", "invoiceDetails"],
  },
  {
    name: "Content",
    types: ["text", "customerInfo", "lineItems", "totals", "summaryTable", "keyValueList", "taxDetails"],
  },
  {
    name: "Dynamic",
    types: ["pageNumber", "carriedForward", "broughtForward"],
  },
  {
    name: "Extras",
    types: ["image", "signature", "paymentTerms", "qrCode", "barcode"],
  },
  {
    name: "Layout",
    types: ["twoColumn", "threeColumn", "fourColumn", "verticalLayout", "divider", "spacer", "pageBreak", "footer"],
  },
];

export const ELEMENT_TYPES = {
  companyLogo: {
    label: "Company Logo",
    icon: "Image",
    description: "Logo image placeholder",
    defaultProps: {
      src: "",
      ejsBinding: "",
      width: 150,
      height: 60,
      alignment: "left",
      marginTop: 0,
      marginBottom: 12,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  heading: {
    label: "Heading",
    icon: "Heading1",
    description: "Title / section heading",
    defaultProps: {
      content: "INVOICE",
      ejsBinding: "",
      fontSize: 28,
      fontWeight: "bold",
      fontFamily: "Arial, sans-serif",
      textAlign: "left",
      color: "#000000",
      letterSpacing: 2,
      textTransform: "uppercase",
      marginTop: 0,
      marginBottom: 12,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  text: {
    label: "Text Block",
    icon: "Type",
    description: "Custom text or EJS content",
    defaultProps: {
      content: "Enter your text here",
      richText: false,
      richContent: "<p>Enter your text here</p>",
      ejsBinding: "",
      fontSize: 12,
      fontWeight: "normal",
      fontStyle: "normal",
      fontFamily: "Arial, sans-serif",
      textAlign: "left",
      color: "#000000",
      lineHeight: 1.5,
      marginTop: 0,
      marginBottom: 8,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  invoiceDetails: {
    label: "Invoice Details",
    icon: "Hash",
    description: "Invoice #, date, due date",
    defaultProps: {
      fields: [
        { label: "Invoice #", value: "INV-001", ejsBinding: "invoice.number" },
        { label: "Date", value: "2025-01-15", ejsBinding: "invoice.date" },
        {
          label: "Due Date",
          value: "2025-02-15",
          ejsBinding: "invoice.dueDate",
        },
      ],
      fontSize: 12,
      fontFamily: "Arial, sans-serif",
      labelColor: "#000000",
      valueColor: "#000000",
      labelWidth: 80,
      labelAlign: "left",
      valueAlign: "right",
      alignment: "right",
      marginTop: 0,
      marginBottom: 12,
      paddingTop: 8,
      paddingBottom: 8,
      paddingLeft: 8,
      paddingRight: 8,
    },
  },
  customerInfo: {
    label: "Customer Info",
    icon: "User",
    description: "Bill-to / ship-to details",
    defaultProps: {
      title: "Bill To",
      fields: [
        { label: "", value: "John Doe", ejsBinding: "customer.name" },
        {
          label: "",
          value: "123 Main Street",
          ejsBinding: "customer.address",
        },
        {
          label: "",
          value: "City, State 12345",
          ejsBinding: "customer.cityState",
        },
        {
          label: "",
          value: "john@example.com",
          ejsBinding: "customer.email",
        },
      ],
      fontSize: 12,
      fontFamily: "Arial, sans-serif",
      titleFontSize: 13,
      titleFontWeight: "bold",
      titleColor: "#000000",
      color: "#000000",
      marginTop: 0,
      marginBottom: 12,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  lineItems: {
    label: "Line Items Table",
    icon: "Table",
    description: "Invoice items table",
    defaultProps: {
      columns: [
        { header: "#", key: "index", width: "5%", align: "center", showTotal: false },
        { header: "Description", key: "description", width: "45%", align: "left", showTotal: false },
        { header: "Qty", key: "quantity", width: "10%", align: "center", showTotal: false },
        { header: "Unit Price", key: "unitPrice", width: "20%", align: "right", showTotal: false },
        { header: "Amount", key: "amount", width: "20%", align: "right", showTotal: true },
      ],
      loopVariable: "items",
      sampleRows: 3,
      columnGroups: [],
      allCellBorders: false,
      // Manual pagination overrides — set non-zero to bypass the automatic
      // height-based estimator and force pagination on these limits instead.
      maxLinesPerPage: 0,
      maxCharsPerLine: 0,
      // Data key whose long-text value should drive wrap-aware pagination
      // (e.g. "description", "productGrade", "itemDescription"). When empty,
      // the EJS pagination loop falls back to base-lines-per-item only.
      paginationWrapKey: "",
      showTotalRow: false,
      totalLabel: "Total",
      headerBgColor: "#F3F4F6",
      headerTextColor: "#000000",
      headerFontWeight: "bold",
      borderColor: "#000000",
      fontSize: 11,
      fontFamily: "Arial, sans-serif",
      cellPadding: 8,
      stripedRows: false,
      stripedColor: "#F9FAFB",
      subRows: [],
      marginTop: 12,
      marginBottom: 12,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  totals: {
    label: "Totals",
    icon: "DollarSign",
    description: "Subtotal, tax, total",
    defaultProps: {
      rows: [
        {
          label: "Subtotal",
          ejsBinding: "totals.subtotal",
          fontWeight: "normal",
        },
        { label: "Tax", ejsBinding: "totals.tax", fontWeight: "normal" },
        { label: "Total", ejsBinding: "totals.total", fontWeight: "bold" },
      ],
      fontSize: 12,
      fontFamily: "Arial, sans-serif",
      labelColor: "#000000",
      valueColor: "#000000",
      labelAlign: "left",
      valueAlign: "right",
      alignment: "right",
      width: 250,
      marginTop: 8,
      marginBottom: 12,
      paddingTop: 8,
      paddingBottom: 8,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  divider: {
    label: "Divider",
    icon: "Minus",
    description: "Horizontal line separator",
    defaultProps: {
      color: "#000000",
      thickness: 1,
      style: "solid",
      marginTop: 12,
      marginBottom: 12,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  spacer: {
    label: "Spacer",
    icon: "MoveVertical",
    description: "Vertical space",
    defaultProps: {
      height: 24,
      marginTop: 0,
      marginBottom: 0,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  keyValueList: {
    label: "Key-Value List",
    icon: "ListChecks",
    description: "Lightweight list of label : value rows (each value bound to an EJS path)",
    defaultProps: {
      // Optional static heading rendered above the rows (plain text, not EJS).
      componentHeading: "",
      items: [
        { id: "kv-1", layoutPattern: "single", label: "Invoice #", ejsBinding: "invoice.number", rowType: "label_value", staticText: "", defaultValue: "", rowFontSize: "", rowIsBold: false },
        { id: "kv-2", layoutPattern: "single", label: "Date",      ejsBinding: "invoice.date",   rowType: "label_value", staticText: "", defaultValue: "", rowFontSize: "", rowIsBold: false },
      ],
      fontSize: 11,
      fontFamily: "Arial, sans-serif",
      color: "#000000",
      labelColor: "#000000",
      valueColor: "#000000",
      labelWidth: "40%",
      labelAlign: "left",
      valueAlign: "left",
      gap: 4,
      verticalGap: 4,
      marginTop: 0,
      marginBottom: 8,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  taxDetails: {
    label: "Tax Details",
    icon: "Receipt",
    description: "Pre-loop summary, looped per-row breakdown, and post-loop totals — typical for GST/tax tables",
    defaultProps: {
      // Lines printed once BEFORE the loop (e.g. "Tax Summary" heading + subtotal)
      preLoopItems: [
        { id: "pre-1", label: "Sub Total", ejsBinding: "totals.subTotal", isBold: false },
      ],
      // Loop config — repeats once per element of `loopVariable`
      loopVariable: "tax_detail",
      loopRowLabelKey: "label",
      loopRowValueKey: "amount",
      sampleRows: 2,
      // Lines printed once AFTER the loop
      postLoopItems: [
        { id: "post-1", label: "Grand Total", ejsBinding: "totals.grandTotal", isBold: true },
      ],
      fontSize: 11,
      fontFamily: "Arial, sans-serif",
      color: "#000000",
      labelColor: "#000000",
      valueColor: "#000000",
      labelWidth: "60%",
      labelAlign: "left",
      valueAlign: "right",
      gap: 4,
      rowPadding: 4,
      sectionDividerColor: "#000000",
      sectionDividerWidth: 1,
      marginTop: 0,
      marginBottom: 8,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  image: {
    label: "Image",
    icon: "ImagePlus",
    description: "Custom image",
    defaultProps: {
      src: "",
      ejsBinding: "",
      width: 200,
      height: 120,
      alignment: "center",
      borderRadius: 0,
      marginTop: 0,
      marginBottom: 12,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  signature: {
    label: "Signature",
    icon: "PenTool",
    description: "Signature line area",
    defaultProps: {
      label: "Authorized Signature",
      lineWidth: 200,
      lineColor: "#000000",
      fontSize: 11,
      fontFamily: "Arial, sans-serif",
      color: "#000000",
      alignment: "left",
      marginTop: 24,
      marginBottom: 12,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  paymentTerms: {
    label: "Payment Terms",
    icon: "FileText",
    description: "Terms and conditions",
    defaultProps: {
      content:
        "Payment is due within 30 days of invoice date. Late payments may incur a 2% monthly fee.",
      fontSize: 10,
      fontFamily: "Arial, sans-serif",
      color: "#000000",
      lineHeight: 1.5,
      marginTop: 12,
      marginBottom: 12,
      paddingTop: 8,
      paddingBottom: 8,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  qrCode: {
    label: "QR Code",
    icon: "QrCode",
    description: "QR code for payment/ref",
    defaultProps: {
      data: "https://example.com/pay",
      ejsBinding: "invoice.qrCodeUrl",
      size: 100,
      alignment: "right",
      marginTop: 12,
      marginBottom: 12,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  barcode: {
    label: "Barcode",
    icon: "ScanLine",
    description: "Barcode for scanning",
    defaultProps: {
      data: "INV-001",
      ejsBinding: "invoice.number",
      width: 200,
      height: 50,
      alignment: "center",
      marginTop: 12,
      marginBottom: 12,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  footer: {
    label: "Footer",
    icon: "AlignCenter",
    description: "Footer text",
    defaultProps: {
      content: "Thank you for your business!",
      ejsBinding: "",
      fontSize: 10,
      fontFamily: "Arial, sans-serif",
      textAlign: "center",
      color: "#000000",
      marginTop: 24,
      marginBottom: 0,
      paddingTop: 8,
      paddingBottom: 8,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  twoColumn: {
    label: "Two Columns",
    icon: "Columns2",
    description: "Side-by-side layout",
    defaultProps: {
      leftWidth: "40%",
      gap: 20,
      verticalAlign: "top",
      leftColumn: {
        type: "companyLogo",
        props: {
          src: "",
          ejsBinding: "",
          width: 150,
          height: 60,
          alignment: "left",
          marginTop: 0,
          marginBottom: 0,
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
        },
      },
      rightColumn: {
        type: "invoiceDetails",
        props: {
          fields: [
            { label: "Invoice #", value: "INV-001", ejsBinding: "invoice.number" },
            { label: "Date", value: "2025-01-15", ejsBinding: "invoice.date" },
            { label: "Due Date", value: "2025-02-15", ejsBinding: "invoice.dueDate" },
          ],
          fontSize: 12,
          fontFamily: "Arial, sans-serif",
          labelColor: "#000000",
          valueColor: "#000000",
          labelWidth: 80,
          alignment: "right",
          marginTop: 0,
          marginBottom: 0,
          paddingTop: 8,
          paddingBottom: 8,
          paddingLeft: 8,
          paddingRight: 8,
        },
      },
      marginTop: 0,
      marginBottom: 12,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  pageBreak: {
    label: "Page Break",
    icon: "Scissors",
    description: "Force new page",
    defaultProps: {
      marginTop: 10,
      marginBottom: 10,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  threeColumn: {
    label: "Three Columns",
    icon: "Columns3",
    description: "Three-column side-by-side layout",
    defaultProps: {
      leftWidth: "33%",
      midWidth: "34%",
      gap: 16,
      verticalAlign: "top",
      leftColumn: { type: "text", props: { content: "Left column", fontSize: 12, fontFamily: "Arial, sans-serif", color: "#000000", textAlign: "left", fontWeight: "normal", fontStyle: "normal", lineHeight: 1.5, marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0 } },
      midColumn: { type: "text", props: { content: "Middle column", fontSize: 12, fontFamily: "Arial, sans-serif", color: "#000000", textAlign: "center", fontWeight: "normal", fontStyle: "normal", lineHeight: 1.5, marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0 } },
      rightColumn: { type: "text", props: { content: "Right column", fontSize: 12, fontFamily: "Arial, sans-serif", color: "#000000", textAlign: "right", fontWeight: "normal", fontStyle: "normal", lineHeight: 1.5, marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0 } },
      marginTop: 0,
      marginBottom: 12,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  fourColumn: {
    label: "Four Columns",
    icon: "LayoutGrid",
    description: "Four-column side-by-side layout",
    defaultProps: {
      col1Width: "25%",
      col2Width: "25%",
      col3Width: "25%",
      col4Width: "25%",
      gap: 12,
      verticalAlign: "top",
      col1: { type: "text", props: { content: "Column 1", fontSize: 12, fontFamily: "Arial, sans-serif", color: "#000000", textAlign: "left",   fontWeight: "normal", fontStyle: "normal", lineHeight: 1.5, marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0 } },
      col2: { type: "text", props: { content: "Column 2", fontSize: 12, fontFamily: "Arial, sans-serif", color: "#000000", textAlign: "left",   fontWeight: "normal", fontStyle: "normal", lineHeight: 1.5, marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0 } },
      col3: { type: "text", props: { content: "Column 3", fontSize: 12, fontFamily: "Arial, sans-serif", color: "#000000", textAlign: "left",   fontWeight: "normal", fontStyle: "normal", lineHeight: 1.5, marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0 } },
      col4: { type: "text", props: { content: "Column 4", fontSize: 12, fontFamily: "Arial, sans-serif", color: "#000000", textAlign: "right",  fontWeight: "normal", fontStyle: "normal", lineHeight: 1.5, marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0 } },
      marginTop: 0,
      marginBottom: 12,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  verticalLayout: {
    label: "Vertical Layout",
    icon: "Rows",
    description: "Stack-builder container — drop any component into each row",
    defaultProps: {
      // Each row holds a single nested child element (can be any registered
      // type — text, lineItems, twoColumn, even another verticalLayout).
      // childType=null means an empty placeholder slot.
      rows: [
        { id: "vrow-1", childType: null, childProps: {} },
        { id: "vrow-2", childType: null, childProps: {} },
      ],
      gap: 8,
      marginTop: 0,
      marginBottom: 12,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  summaryTable: {
    label: "Summary Table",
    icon: "TableProperties",
    description: "GST/HSN or any repeating summary",
    defaultProps: {
      columns: [
        { header: "HSN Code", key: "hsnCode", width: "15%", align: "left", showTotal: false },
        { header: "Description", key: "description", width: "25%", align: "left", showTotal: false },
        { header: "Taxable Value", key: "taxableValue", width: "15%", align: "right", showTotal: true },
        { header: "Rate %", key: "gstRate", width: "10%", align: "right", showTotal: false },
        { header: "CGST", key: "cgst", width: "10%", align: "right", showTotal: true },
        { header: "SGST", key: "sgst", width: "10%", align: "right", showTotal: true },
        { header: "Total Tax", key: "totalTax", width: "15%", align: "right", showTotal: true },
      ],
      loopVariable: "gstSummary",
      sampleRows: 3,
      columnGroups: [],
      allCellBorders: false,
      showTotalRow: true,
      totalLabel: "Total",
      headerBgColor: "#F3F4F6",
      headerTextColor: "#000000",
      headerFontWeight: "bold",
      borderColor: "#000000",
      fontSize: 11,
      fontFamily: "Arial, sans-serif",
      cellPadding: 8,
      stripedRows: false,
      stripedColor: "#F9FAFB",
      marginTop: 12,
      marginBottom: 12,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  pageNumber: {
    label: "Page Number",
    icon: "Hash",
    description: "Current page / total",
    defaultProps: {
      format: "Page {current} of {total}",
      fontSize: 10,
      fontFamily: "Arial, sans-serif",
      textAlign: "center",
      color: "#000000",
      marginTop: 0,
      marginBottom: 0,
      paddingTop: 4,
      paddingBottom: 4,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  carriedForward: {
    label: "Carried Forward",
    icon: "ArrowDownToLine",
    description: "Total carried to next page",
    defaultProps: {
      label: "Carried Forward",
      amountKey: "amount",
      fontSize: 11,
      fontFamily: "Arial, sans-serif",
      fontWeight: "bold",
      textAlign: "right",
      color: "#000000",
      marginTop: 4,
      marginBottom: 0,
      paddingTop: 4,
      paddingBottom: 4,
      paddingLeft: 8,
      paddingRight: 8,
    },
  },
  broughtForward: {
    label: "Brought Forward",
    icon: "ArrowUpFromLine",
    description: "Total from previous page",
    defaultProps: {
      label: "Brought Forward",
      amountKey: "amount",
      fontSize: 11,
      fontFamily: "Arial, sans-serif",
      fontWeight: "bold",
      textAlign: "right",
      color: "#000000",
      marginTop: 0,
      marginBottom: 4,
      paddingTop: 4,
      paddingBottom: 4,
      paddingLeft: 8,
      paddingRight: 8,
    },
  },
};

export function createElement(type) {
  const def = ELEMENT_TYPES[type];
  if (!def) throw new Error(`Unknown element type: ${type}`);
  return {
    id: `el-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    type,
    label: def.label,
    props: {
      borderWidth: 0,
      borderColor: "#000000",
      borderStyle: "solid",
      borderRadius: 0,
      ...JSON.parse(JSON.stringify(def.defaultProps)),
    },
  };
}

export function generateId() {
  return `el-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}

/**
 * Standard print page sizes (portrait orientation).
 * - widthMM / heightMM: physical dimensions used by all pagination math.
 * - cssSize: the keyword emitted in @page { size: ... } for jsreport / Chrome.
 *   Null for Custom (we emit explicit "Wmm Hmm" instead).
 * - widthPx / heightPx: dimensions @96 DPI used by on-screen previews
 *   (1mm ≈ 3.7795275591 px).
 */
export const PAGE_SIZES = {
  A4:     { label: "A4 (210 × 297 mm)",        widthMM: 210,    heightMM: 297,   cssSize: "A4",     widthPx: 794,  heightPx: 1123 },
  Letter: { label: "Letter (8.5 × 11 in)",     widthMM: 215.9,  heightMM: 279.4, cssSize: "Letter", widthPx: 816,  heightPx: 1056 },
  Legal:  { label: "Legal (8.5 × 14 in)",      widthMM: 215.9,  heightMM: 355.6, cssSize: "Legal",  widthPx: 816,  heightPx: 1344 },
  A3:     { label: "A3 (297 × 420 mm)",        widthMM: 297,    heightMM: 420,   cssSize: "A3",     widthPx: 1123, heightPx: 1587 },
  A5:     { label: "A5 (148 × 210 mm)",        widthMM: 148,    heightMM: 210,   cssSize: "A5",     widthPx: 559,  heightPx: 794  },
  Custom: { label: "Custom (mm × mm)",         widthMM: 210,    heightMM: 297,   cssSize: null,     widthPx: 794,  heightPx: 1123 },
};

const _mmToPx = (mm) => Math.round(mm * 3.7795275591);

/**
 * Resolves the final page-size object, applying:
 *   - custom mm dimensions when key === "Custom"
 *   - orientation swap (landscape rotates portrait dims)
 *   - cssPageRule ready to drop into `@page { size: ... }`
 *
 * @param {string} key  one of PAGE_SIZES keys (or unknown → falls back to A4)
 * @param {object} [settings]  full pageSettings; used for customWidthMM/customHeightMM/orientation
 */
export function getPageSize(key, settings = {}) {
  let base = PAGE_SIZES[key] || PAGE_SIZES.A4;

  // Custom dimensions
  if (key === "Custom") {
    const w = Number(settings.customWidthMM) || base.widthMM;
    const h = Number(settings.customHeightMM) || base.heightMM;
    base = { ...base, widthMM: w, heightMM: h, widthPx: _mmToPx(w), heightPx: _mmToPx(h) };
  }

  const isLandscape = settings.orientation === "landscape";
  if (isLandscape) {
    base = {
      ...base,
      widthMM: base.heightMM,
      heightMM: base.widthMM,
      widthPx: base.heightPx,
      heightPx: base.widthPx,
    };
  }

  // CSS @page rule value
  let cssPageRule;
  if (base.cssSize) {
    cssPageRule = isLandscape ? `${base.cssSize} landscape` : base.cssSize;
  } else {
    // Custom — emit explicit dimensions in current orientation
    cssPageRule = `${base.widthMM}mm ${base.heightMM}mm`;
  }

  return { ...base, cssPageRule, orientation: isLandscape ? "landscape" : "portrait" };
}

export const DEFAULT_PAGE_SETTINGS = {
  pageSize: "A4",
  orientation: "portrait",
  customWidthMM: 210,
  customHeightMM: 297,
  marginTop: 8,
  marginBottom: 8,
  marginLeft: 8,
  marginRight: 8,
  fontFamily: "Arial, sans-serif",
  fontSize: 12,
  sectionPadding: {
    reportHeader: { top: 0, bottom: 0 },
    pageHeader: { top: 0, bottom: 0 },
    body: { top: 0, bottom: 0 },
    pageFooter: { top: 0, bottom: 0 },
    reportFooter: { top: 0, bottom: 0 },
  },
};

export const FONT_OPTIONS = [
  "Arial, sans-serif",
  "Helvetica, sans-serif",
  "Georgia, serif",
  "Times New Roman, serif",
  "Courier New, monospace",
  "Verdana, sans-serif",
  "Trebuchet MS, sans-serif",
  "Tahoma, sans-serif",
];

export const COLUMN_ELEMENT_TYPES = [
  "companyLogo", "heading", "text", "invoiceDetails", "customerInfo",
  "lineItems", "totals", "summaryTable", "divider", "spacer",
  "signature", "qrCode", "barcode", "image", "paymentTerms",
  "footer", "pageNumber", "carriedForward", "broughtForward", "pageBreak",
  "twoColumn", "threeColumn", "fourColumn", "verticalLayout",
  "keyValueList", "taxDetails",
];

export const SECTION_DEFS = {
  reportHeader: { label: "Report Header", description: "First page only", color: "#3B82F6" },
  pageHeader: { label: "Page Header", description: "Every page", color: "#8B5CF6" },
  body: { label: "Body", description: "Main content", color: "#059669" },
  pageFooter: { label: "Page Footer", description: "Every page", color: "#D97706" },
  reportFooter: { label: "Report Footer", description: "Last page only", color: "#DC2626" },
};

export const SECTION_ORDER = ["reportHeader", "pageHeader", "body", "pageFooter", "reportFooter"];

export function createDefaultSections() {
  return {
    reportHeader: [],
    pageHeader: [],
    body: [],
    pageFooter: [],
    reportFooter: [],
  };
}

export function createCustomElement(definition) {
  return {
    id: generateId(),
    type: "custom",
    label: definition.name,
    props: {
      customElementId: definition.id,
      name: definition.name,
      fields: JSON.parse(JSON.stringify(definition.fields)),
      layout: definition.style?.layout || "vertical",
      fontSize: definition.style?.fontSize || 12,
      fontFamily: definition.style?.fontFamily || "Arial, sans-serif",
      color: definition.style?.color || "#000000",
      titleFontSize: definition.style?.titleFontSize || 13,
      titleFontWeight: definition.style?.titleFontWeight || "bold",
      titleColor: definition.style?.titleColor || "#000000",
      marginTop: 0,
      marginBottom: 12,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  };
}

export const CUSTOM_ICON_OPTIONS = [
  "Box", "Building", "CreditCard", "FileText", "Globe",
  "Heart", "Home", "Mail", "MapPin", "Package",
  "Phone", "Shield", "Star", "Tag", "Truck",
  "User", "Wallet", "Briefcase", "Calendar", "Clock",
  "Database", "DollarSign", "Flag", "Gift", "Key",
  "Layers", "Lock", "Map", "Percent", "Receipt",
];

export const FIELD_TYPES = [
  { value: "text", label: "Text" },
  { value: "number", label: "Number" },
  { value: "date", label: "Date" },
  { value: "image", label: "Image" },
  { value: "textarea", label: "Textarea" },
];
